<template>
  <div class="etr">
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="auto">
            <div class="inline-block">
              <i class="fa fa-car fa-2x mr-1 text-primary"></i>

              <span class="h4 ml-1 text-primary">Confirmation No: {{ items[0].confirmno }}</span>
            </div>
          </b-col>

          <b-col class="text-right">
            <b-button-group>
              <b-button class="mr-1" squared size="sm" variant="primary" @click="download()">
                <i :class="busy
                  ? 'fa fa-spinner fa-spin pr-3'
                  : 'fa fa-file-pdf-o pr-3'
                  "></i>Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group>
          </b-col>
        </b-row>
      </b-card-header>

      <div class="h1 text-center text-primary">
        <b-spinner v-if="busy" type="grow" label="Loading Receipt"></b-spinner>
      </div>

      <b-card-body v-if="items.length > 0 && documentformat == 'CAR_1'">
        <div id="eticket" class="mb-3 p-5 background-white text-secondary eticket">
          <div class="border-black p-4">
            <b-row>
              <b-col cols="2">
              </b-col>
              <b-col class="text-center"><img class="logo mb-3" src="/img/brand/RGB Travel Places Primary Logo.bmp"
                  alt="Travel Places" height="70" width="190" /><br />
                <span>
                  Travel Places, in association with American Express Global
                  Business Travel
                </span>
              </b-col>
              <b-col cols="2">
                <img class="logo h-30px mt-4" src="/img/brand/IATA.jpg" alt="IATA" />
              </b-col>
            </b-row>
            <b-row class="text-center strong">
              <b-col>Podium House 61 Chapel Road, Worthing, West Sussex, BN11 1HR
                T: +44 (0) 1903 832888 F: +44 (0) 1903 231179</b-col>
            </b-row>
          </div>
          <div class="border-black border-top-none py-3">
            <div class="border-bottom-black text-center large strong uppercase pb-3">
              Car Rental Voucher
            </div>

            <b-row class="p-3">
              <b-col> Car Rental Company:
                <span v-if="items[0].vendorname" class="strong">{{ items[0].vendorname }}</span><br />
                <span v-if="items[0].vendorlocation">
                  Local Phone Number:
                  <span class="strong">{{ items[0].vendorlocation }}</span>
                  <br />
                </span>
                <br />
                Travel Places Agent Reference:<br />
                <span v-if="items[0].agent" class="strong">{{ items[0].agentname }}</span>
                <!-- <span v-if="items[0].consultant">
                                  Email: <span class="strong">{{ items[0].consultant.email }}</span>
                              </span> -->
              </b-col>
              <b-col class="text-right">
                <img class="logo h-50px" :src="items[0].vendorlogo" :alt="items[0].vendorname"
                  :title="items[0].vendorname" />
              </b-col>
            </b-row>

          </div>
          <div class="border-black border-top-none text-center large strong uppercase py-3">
            BOOKING DETAILS
          </div>
          <div class="border-black border-top-none p-4">
            <b-row class="pb-3">
              <b-col cols="4" class="text-right"> Confirmation number:</b-col>
              <b-col>
                <h6 class="strong">{{ items[0].confirmno }} </h6>
              </b-col>
            </b-row>
            <b-row class="pb-4">
              <b-col cols="4" class="text-right"> Driver Name (s): </b-col>
              <b-col> <span class="strong">{{ items[0].title }} {{ items[0].firstname }} {{
                items[0].surname }}</span></b-col>
            </b-row>
            <b-row class="pb-4" v-if="items[0].equipment">
              <b-col cols="4" class="text-right">Car Group:</b-col>
              <b-col> <span class="strong">{{ items[0].equipment }} - {{ items[0].equipmentname
              }}</span></b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="text-right">Pickup DateTime:</b-col>
              <b-col><span class="strong" v-if="items[0].start_at">{{ (items[0].start_at * 0.001) |
                moment("utc", "DD MMM YYYY HH:mm")
              }} </span></b-col>
              <b-col cols="2" class="text-right">Return DateTime:</b-col>
              <b-col> <span class="strong" v-if="items[0].end_at">{{ (items[0].end_at * 0.001) | moment("utc",
                "DD MMM YYYY HH:mm")
              }}</span> </b-col>
            </b-row>
            <b-row v-if="items[0].startcityname || items[0].endcityname">
              <b-col cols="2" class="text-right">Pickup Airport:</b-col>
              <b-col> <span class="strong" v-if="items[0].startcityname">{{ items[0].startcityname
              }} ( {{ items[0].startcity }} )</span></b-col>

              <b-col cols="2" class="text-right">Return Airport:</b-col>
              <b-col>
                <span class="strong" v-if="items[0].endcityname">{{
                  items[0].endcityname
                }} ( {{ items[0].endcity }} )</span></b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="text-right">Pickup Location:</b-col>
              <b-col> <span class="strong" v-if="items[0].startlocation">{{ items[0].startlocation
              }}</span></b-col>

              <b-col cols="2" class="text-right">Return Location:</b-col>
              <b-col>
                <span class="strong" v-if="items[0].endlocation">{{
                  items[0].endlocation
                }}</span></b-col>
            </b-row>
          </div>
          <div v-if="items[0].voucherinfo">
            <div class="border-black border-top-none text-center large strong uppercase py-3">
              BOOKING NOTES
            </div>
            <div class="border-black border-top-none p-4">
              {{ items[0].voucherinfo }}
            </div>
          </div>
          <div class="border-black border-top-none text-center large strong uppercase py-3">
            <span class="strong">Company to be invoiced</span>
          </div>
          <div class="border-black border-top-none p-4 uppercase ">
            <b-row>
              <b-col cols="4" class="text-right">Account:</b-col>
              <b-col> <span class="strong">{{ items[0].slac }}</span></b-col>
            </b-row>
            <b-row>
              <b-col cols="4" class="text-right">Company: </b-col>
              <b-col> <span class="strong">{{ items[0].to }}</span></b-col>
            </b-row>
            <b-row>
              <b-col cols="4" class="text-right">Account:</b-col>
              <b-col><span class="strong">Paid By Travel Places</span></b-col>
            </b-row>
          </div>
        </div>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button-group>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "CarView",
  data() {
    return {
      busy: false,
      loading: false,
      items: [],
      documentformat: "CAR_1",
    };
  },
  methods: {
    async load() {
      this.busy = true;

      this.items = [];

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),

      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookings(
              $selected: [Booking_input]
            
            ) {
              bookings(
                selected: $selected
              
              ) {
                  id 
                  issued_at 
                  type 
                  locator 
                  vendorcode
                  vendorname
                  vendorlocation
                  vendorlogo
                  status 
                  confirmno 
                  passenger 
                  surname 
                  firstname 
                  title 
                  startcity
                  startcityname
                  startlocation
                  start_at 
                  endcity
                  endcityname
                  endlocation  
                  end_at
                  days 
                  qty                  
                  equipment
                  equipmentname
                  slac 
                  to
                  blac 
                  eventcode 
                  eventname
                  agent
                  agentname
                  settlementtype 
                  settlementno 
                  invoiceno
                  voucherinfo
                  emailed_at 
                  notes 
                  created_by 
                  updated_by 
                  created_at 
                  updated_at 
              }
            }
          `,
          variables,
        });

        this.items = response.data.bookings;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        documentformat: this.documentformat,
        dateformat: "YYYY-MM-DD",
      };
      console.log("download variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookings(
              $selected: [Booking_input]                       
              $documentformat: String
              $dateformat: String
            ) {
              bookings(
                selected: $selected                             
                documentformat: $documentformat
                dateformat: $dateformat
              ) {
                  documentname
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.bookings.length > 0) {
          let item = response.data.bookings[0];
          console.log("downloaded item", item);

          let byteCharacters = atob(item.documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, item.documentname + ".pdf");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style></style>
